import { requestInstance, request } from "./speedMateAxiosUtils";
import { ApiParams } from "./types";

export default async ({ method, url, queryParams, requestBody }: ApiParams) => {
  const instance = requestInstance.getInstance();
  return await request(instance, method, url, queryParams, requestBody);
};
